import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <div className="pt-12 pb-8 px-4 max-w-4xl mx-auto text-center" data-id="element-150">
      <div className="inline-block bg-brand-card border border-brand-borderGlow/30 rounded-full px-4 py-1.5 font-semibold text-brand-subtitle mb-4 text-[12px] tracking-[0.15em] uppercase shadow-violet-glow" data-id="element-151">
        💃 ATENCIÓN: INSTRUCTORES DE BACHATA
      </div>

      <h1 className="font-display text-brand-title md:text-6xl font-bold tracking-tight mb-6 text-[40px] leading-tight" data-id="element-152">
        ¿Te quita tiempo planificar tus clases? Resuélvelo hoy.
      </h1>

      <div className="my-6 flex justify-center" data-id="element-153">
        <img src="https://cdn.magicpatterns.com/uploads/uBAEsi8AVseHCSgsFmEDdQ/mockup-bachata-v99.webp.webp" alt="El Manual del Instructor de Bachata — 6 Tomos + 3 Bonos" width={800} height={800} fetchPriority="high" loading="eager" decoding="async" className="w-full max-w-2xl" data-id="element-154" />
      </div>

      <p className="text-xl md:text-2xl text-brand-subtitle font-semibold mb-6 tracking-wide" data-id="element-155">
        Deja de improvisar. Empieza a enseñar con estructura, seguridad y
        resultados.
      </p>

      <div className="flex items-center justify-center gap-2 mb-6 text-sm" data-id="element-156">
        <div className="flex text-brand-gold" data-id="element-157">⭐⭐⭐⭐⭐</div>
        <span className="text-brand-text font-medium" data-id="element-158">4.9/5</span>
        <span className="text-brand-textMuted" data-id="element-159">·</span>
        <span className="text-brand-text font-medium" data-id="element-160">
          🔥 24 instructores lo compraron hoy
        </span>
      </div>

      <button onClick={scrollToPricing} className="bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-xl md:text-2xl py-4 px-8 rounded-2xl transition-all hover:scale-105 active:scale-95 shadow-gold-glow-lg w-full md:w-auto mb-4 tracking-wide" data-id="element-161">
        🚀 ¡QUIERO MI MANUAL AHORA!
      </button>

      <div className="text-brand-textMuted font-medium text-sm tracking-wide" data-id="element-162">
        🇪🇸 +300 instructores ya enseñan mejor en España
      </div>
    </div>;
}